import LoadingShowDetailView from './LoadingShowDetailView';

export default LoadingShowDetailView;
